var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterContentInit, Injector, OnChanges, OnInit, SimpleChanges, } from '@angular/core';
import * as moment from 'moment-timezone';
import { NgbDateParserFormatter, NgbDatepickerI18n, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { ControlContainer, ControlValueAccessor, NgControl } from '@angular/forms';
var I18n = /** @class */ (function () {
    function I18n() {
        this.language = 'ru';
        this.I18N_VALUES = {
            'ru': {
                weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
                months: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            }
        };
    }
    return I18n;
}());
export { I18n };
var CustomDatepickerI18n = /** @class */ (function (_super) {
    __extends(CustomDatepickerI18n, _super);
    function CustomDatepickerI18n(_i18n) {
        var _this = _super.call(this) || this;
        _this._i18n = _i18n;
        return _this;
    }
    CustomDatepickerI18n.prototype.getWeekdayShortName = function (weekday) {
        return this._i18n.I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
    };
    CustomDatepickerI18n.prototype.getMonthShortName = function (month) {
        return this._i18n.I18N_VALUES[this._i18n.language].months[month - 1];
    };
    CustomDatepickerI18n.prototype.getMonthFullName = function (month) {
        return this.getMonthShortName(month);
    };
    CustomDatepickerI18n.prototype.getDayAriaLabel = function (date) {
        return date.year + "-" + date.month + "-" + date.day;
    };
    return CustomDatepickerI18n;
}(NgbDatepickerI18n));
export { CustomDatepickerI18n };
var CustomParserFormatter = /** @class */ (function (_super) {
    __extends(CustomParserFormatter, _super);
    function CustomParserFormatter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._format = 'YYYY-MM-DD';
        return _this;
    }
    CustomParserFormatter.prototype.parse = function (value) {
        var dtIn = moment(value, this._format, true);
        if (dtIn.isValid()) {
            return dt2model(dtIn);
        }
        return null;
    };
    CustomParserFormatter.prototype.format = function (date) {
        if (date == null) {
            return '';
        }
        var d = Object.assign({}, date);
        d.month = (d.month === 0 ? 11 : d.month - 1);
        return moment(d).format(this._format);
    };
    return CustomParserFormatter;
}(NgbDateParserFormatter));
export { CustomParserFormatter };
var dt2model = function (dateM) {
    return {
        year: dateM.year(),
        month: dateM.month() + 1,
        day: dateM.date()
    };
};
var ɵ0 = dt2model;
var DatepickerComponent = /** @class */ (function () {
    function DatepickerComponent(injector, controlContainer) {
        this.injector = injector;
        this.controlContainer = controlContainer;
        this.format = 'YYYY-MM-DD';
        this.disabled = false;
        this.disabledPast = false;
        this.maxDate = {
            year: 3000,
            month: 12,
            day: 31
        };
        this.formControl = null;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    DatepickerComponent.prototype.ngOnInit = function () {
        this.datepicker['_parserFormatter']._format = this.format;
        if (this.disabledPast) {
            var dt = moment();
            this.minDate = { year: dt.year(), month: dt.month() + 1, day: dt.date() };
        }
        this.datepicker.minDate = this.minDate;
        this.datepicker.maxDate = this.maxDate;
        var dtIn = moment(this.model, this.format, true);
        if (dtIn.isValid()) {
            this.model = dt2model(dtIn);
        }
    };
    DatepickerComponent.prototype.ngAfterContentInit = function () {
        this.ngControl = this.injector.get(NgControl);
        if (!this.ngControl.name) {
            return;
        }
        this.formControl = this.controlContainer.control.get(this.ngControl.name);
        if (this.disabled) {
            this.formControl.disable();
        }
        else {
            this.formControl.enable();
        }
    };
    DatepickerComponent.prototype.ngOnChanges = function (changes) {
        if (changes.disabled && this.formControl) {
            if (changes.disabled.currentValue) {
                this.formControl.disable();
            }
            else {
                this.formControl.enable();
            }
        }
    };
    DatepickerComponent.prototype.onDateSelection = function (date) {
        date.month = (date.month === 0 ? 11 : date.month - 1);
        this.writeValue(moment(date).format(this.format));
    };
    DatepickerComponent.prototype.onInput = function (event) {
        this.writeValue(event.target.value);
    };
    DatepickerComponent.prototype.onClick = function () {
        if (!this.disabled) {
            this.datepicker.toggle();
        }
    };
    DatepickerComponent.prototype.onInputClick = function () {
        // Для статистики показываем календарик ещё и по клику на инпут, для саппорта только по иконке 
        if (this.formControl != null) {
            return;
        }
        if (!this.disabled) {
            this.datepicker.toggle();
        }
    };
    DatepickerComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    DatepickerComponent.prototype.writeValue = function (value) {
        if (value) {
            var dtIn = moment(value, [this.format, 'YYYY-MM-DDTHH:mm:ss.SSSZ'], true);
            if (dtIn.isValid()) {
                this.model = dt2model(dtIn);
            }
            this.onChange(value);
        }
    };
    DatepickerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    DatepickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    return DatepickerComponent;
}());
export { DatepickerComponent };
export { ɵ0 };
